"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRoutingNumberChecksum = void 0;
const routing_number_scrubber_1 = require("./routing-number-scrubber");
const ROUTING_NUMBER_LENGTH = 9;
function calculateRoutingNumberChecksum(routingNumber) {
    const scrubbedRoutingNumber = routing_number_scrubber_1.scrubRoutingNumber(routingNumber);
    let checksum = 0;
    for (let i = 0; i < ROUTING_NUMBER_LENGTH; i += 3) {
        checksum += parseInt(scrubbedRoutingNumber.charAt(i)) * 3;
        checksum += parseInt(scrubbedRoutingNumber.charAt(i + 1)) * 7;
        checksum += parseInt(scrubbedRoutingNumber.charAt(i + 2));
    }
    return checksum;
}
exports.calculateRoutingNumberChecksum = calculateRoutingNumberChecksum;
//# sourceMappingURL=routing-number-checksum-calculator.js.map